var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictureAsPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3335 2.66666H11.3335C9.86683 2.66666 8.66683 3.86666 8.66683 5.33333V21.3333C8.66683 22.8 9.86683 24 11.3335 24H27.3335C28.8002 24 30.0002 22.8 30.0002 21.3333V5.33333C30.0002 3.86666 28.8002 2.66666 27.3335 2.66666ZM27.3335 21.3333H11.3335V5.33333H27.3335V21.3333ZM6.00016 8H3.3335V26.6667C3.3335 28.1333 4.5335 29.3333 6.00016 29.3333H24.6668V26.6667H6.00016V8ZM22.0002 16V12C22.0002 11.2667 21.4002 10.6667 20.6668 10.6667H18.0002V17.3333H20.6668C21.4002 17.3333 22.0002 16.7333 22.0002 16ZM19.3335 12H20.6668V16H19.3335V12ZM24.6668 14.6667H26.0002V13.3333H24.6668V12H26.0002V10.6667H23.3335V17.3333H24.6668V14.6667ZM14.0002 14.6667H15.3335C16.0668 14.6667 16.6668 14.0667 16.6668 13.3333V12C16.6668 11.2667 16.0668 10.6667 15.3335 10.6667H12.6668V17.3333H14.0002V14.6667ZM14.0002 12H15.3335V13.3333H14.0002V12Z",
    fill: "#EAC176"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictureAsPdf);
export default __webpack_public_path__ + "static/media/picture_as_pdf.ba80d3d43e1093ad1388da14dbe1c9c7.svg";
export { ForwardRef as ReactComponent };